import React, { useContext } from 'react';
import userContext from '../../components/ContextComponent/UserContext';

function Journey1(input) {
    const { formData } = useContext(userContext);
    return (
        <div>
            <p>Congratulations {formData.firstName}! You have been conditionally approved<sup>1 </sup>
            for {input.props.data.journeyContent.productName} with a Credit limit<sup>1</sup> of 
            {input.props.apiOutput.creditRange} and no requirement of income documents.T&Cs apply<sup>1</sup>.
            </p>
        </div>
    );
}
export default Journey1;